import React from "react";
import { Tooltip } from "@/components/common/Tooltip";

export interface PrincipalProps {
  /// The raw identity as recorded — shown when nothing resolved, because an
  /// audit row must still say who even after the account is gone.
  id: string;
  name: string | null;
  email: string | null;
}

/// A person in an audit row: the name, with the exact identity in a
/// tooltip. Falls back to the raw id, never to "Unknown".
export const Principal: React.FC<PrincipalProps> = ({ id, name, email }) => {
  const label = name || email || id;
  const exact = email || id;
  if (label === exact) {
    return <span className="text-fg-regular">{label}</span>;
  }
  return (
    <Tooltip title={exact}>
      <span className="cursor-default text-fg-regular">{label}</span>
    </Tooltip>
  );
};
